/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesBatchStatus } from './WebApiModelsEnumerationTypesBatchStatus';
import {
    WebApiModelsEnumerationTypesBatchStatusFromJSON,
    WebApiModelsEnumerationTypesBatchStatusFromJSONTyped,
    WebApiModelsEnumerationTypesBatchStatusToJSON,
} from './WebApiModelsEnumerationTypesBatchStatus';
import type { WebApiModelsEnumerationTypesJobType } from './WebApiModelsEnumerationTypesJobType';
import {
    WebApiModelsEnumerationTypesJobTypeFromJSON,
    WebApiModelsEnumerationTypesJobTypeFromJSONTyped,
    WebApiModelsEnumerationTypesJobTypeToJSON,
} from './WebApiModelsEnumerationTypesJobType';

/**
 * Individual batch job status
 * @export
 * @interface WebApiAdminDtoBatchJobDetailDto
 */
export interface WebApiAdminDtoBatchJobDetailDto {
    /**
     * Batch job ID
     * @type {number}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    id?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesJobType}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    jobType?: WebApiModelsEnumerationTypesJobType;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesBatchStatus}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    status?: WebApiModelsEnumerationTypesBatchStatus;
    /**
     * When the job was created
     * @type {Date}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    createdAt?: Date;
    /**
     * When the job started processing
     * @type {Date}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    startedAt?: Date | null;
    /**
     * When the job completed
     * @type {Date}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    completedAt?: Date | null;
    /**
     * Error message if failed
     * @type {string}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    errorMessage?: string | null;
    /**
     * Company name
     * @type {string}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    companyName?: string | null;
    /**
     * Company ID
     * @type {number}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    companyId?: number;
    /**
     * Total number of items in the job
     * @type {number}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    totalItems?: number;
    /**
     * Number of completed items
     * @type {number}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    completedItems?: number;
    /**
     * Number of failed items
     * @type {number}
     * @memberof WebApiAdminDtoBatchJobDetailDto
     */
    failedItems?: number;
}

/**
 * Check if a given object implements the WebApiAdminDtoBatchJobDetailDto interface.
 */
export function instanceOfWebApiAdminDtoBatchJobDetailDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoBatchJobDetailDtoFromJSON(json: any): WebApiAdminDtoBatchJobDetailDto {
    return WebApiAdminDtoBatchJobDetailDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoBatchJobDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoBatchJobDetailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'jobType': !exists(json, 'jobType') ? undefined : WebApiModelsEnumerationTypesJobTypeFromJSON(json['jobType']),
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesBatchStatusFromJSON(json['status']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'startedAt': !exists(json, 'startedAt') ? undefined : (json['startedAt'] === null ? null : new Date(json['startedAt'])),
        'completedAt': !exists(json, 'completedAt') ? undefined : (json['completedAt'] === null ? null : new Date(json['completedAt'])),
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
        'completedItems': !exists(json, 'completedItems') ? undefined : json['completedItems'],
        'failedItems': !exists(json, 'failedItems') ? undefined : json['failedItems'],
    };
}

export function WebApiAdminDtoBatchJobDetailDtoToJSON(value?: WebApiAdminDtoBatchJobDetailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'jobType': WebApiModelsEnumerationTypesJobTypeToJSON(value.jobType),
        'status': WebApiModelsEnumerationTypesBatchStatusToJSON(value.status),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'startedAt': value.startedAt === undefined ? undefined : (value.startedAt === null ? null : value.startedAt.toISOString()),
        'completedAt': value.completedAt === undefined ? undefined : (value.completedAt === null ? null : value.completedAt.toISOString()),
        'errorMessage': value.errorMessage,
        'companyName': value.companyName,
        'companyId': value.companyId,
        'totalItems': value.totalItems,
        'completedItems': value.completedItems,
        'failedItems': value.failedItems,
    };
}

